"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMultipleHeader = exports.multipleInput = exports.singleInput = exports.StyledSingleHeader = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var _styleConsts = require("../../utils/styleConsts");

var styles = function styles(_ref) {
  var color = _ref.theme.color,
      isSelected = _ref.isSelected,
      minWidth = _ref.minWidth,
      expanded = _ref.expanded;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)(_styleConsts.buttonReset, "\n  min-width:100%;min-height:36px;padding:0px 0px;color:", color.black1, ";border-radius:0px;border-bottom:1px solid ", color.grey2, ";outline:none;fill:", expanded ? color.dark.mars : color.dark.zinc, ";color:white;", isSelected && "\n    color: white;\n  ", "\n\n  &::after{left:0;width:0px;bottom:0px;content:'';position:absolute;transition:border 0.3s ease,width 0.4s ease;border-bottom:1px solid ", color.dark.zinc, ";pointer-events:none;", expanded && "\n      width: 100%\n    ", ";}&::before{left:0;right:0;bottom:0;content:'';position:absolute;transition:border-bottom-color 200ms cubic-bezier(0.4,0,0.2,1) 0ms;border-bottom:1px solid transparent;pointer-events:none;}&:hover{&::before{", !expanded && "\n          border-bottom: 1px solid ".concat(color.dark.zinc, ";\n        "), "}&::after{", expanded && "\n        width: 100%\n      ", "}", !expanded && "\n    fill: ".concat(color.black3, "\n    "), "}&:active,&:focus{border-color:", color.grey1, ";fill:white;&:hover{&::before{border-bottom:0px;}}&::after{width:100%;}}&[disabled]{color:", color.grey1, ";cursor:not-allowed;fill:", color.grey1, ";}& input{font-size:", _styleConsts.font.size.large, ";height:", _styleConsts.height.medium, ";border:none;outline:none;min-width:", minWidth, "px;max-width:100%;&::placeholder{color:white;", isSelected && "\n        color: white;\n      ", "}&:focus::placeholder{color:", color.black3, ";}}& .IconSearch{margin-right:11px;align-self:center;}& .IconAngleDown{margin-left:auto;align-self:center;transition:transform 0.3s,-webkit-transform 0.3s;}& .Tag{margin-right:8px;margin-bottom:6px;color:", color.black1, ";fill:", color.black1, ";}")
  );
};

var multipleStyles = "\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  padding-bottom: 0;\n";
var StyledSingleHeader = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-35ulv90"
})(styles));
exports.StyledSingleHeader = StyledSingleHeader;

var singleInput = function singleInput(_ref2) {
  var color = _ref2.color;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("color:white;background:transparent;flex:1;")
  );
};

exports.singleInput = singleInput;

var multipleInput = function multipleInput(_ref3) {
  var color = _ref3.color;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("color:white;background:transparent;width:100%;min-width:200px !important;")
  );
};

exports.multipleInput = multipleInput;
var StyledMultipleHeader = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-35ulv91"
})(styles, "\n    ", multipleStyles));
exports.StyledMultipleHeader = StyledMultipleHeader;